import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  width: 100%;
`;

export const TooltipPortal = styled.div`
  position: fixed;
  transform: translateX(-50%);
  background: ${(p) => p.theme.colors.primary};
  color: ${(p) => p.theme.colors.onPrimary ?? '#fff'};
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 1rem;
  line-height: 1.1;
  max-width: calc(100vw - 16px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 2147483647;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.06s ease;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);

  &[data-visible='true'] {
    opacity: 1;
  }
`;
